$(document).ready(() => {
    $('.js-price-list-table-dropdown').on('change', function (e) {
        const request = $.ajax({
            method: 'GET',
            url: '/api/price-html/',
            data: {section_id: e.target.value},
        });

        request.done((responseJSON) => {
            const data = responseJSON.data;
            data && $('.js-price-list-table').html(data);
        });
    });
});
